import $ from 'jquery';
import URI from 'urijs';

import Settings from 'source/lib/settings_model';

import BaseView from 'source/lib/base_view';
import template from 'authentication/templates/parts/commonmenu.html';

const query = URI.parseQuery(window.location.search);

const CommonMenuView = BaseView.extend({
    template,
    initialize() {
        if (query.display === 'popup') {
            $('#js-menu-wrapper').addClass('hidden');
            return;
        }
        if (Settings.get('Request.CommonMenuLoader')) {
            this.render();
            const WG = window.WG;

            if (WG && WG.CommonMenu) {
                WG.CommonMenu.trigger('holder_ready');
            }
            $('#js-menu-wrapper').removeClass('hidden');
        }
    }
});

export default CommonMenuView;
export { query };



// WEBPACK FOOTER //
// ./authentication/static-source/js/authentication/parts/commonmenu.js